module.exports = __webpack_public_path__ + "img/08.0dddeae4.png";